export function sortCaseInsensitive(a: string, b: string) {
    return a.localeCompare(b, "en", { sensitivity: "base" });
}
